// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-play-create-clip-modal .modal2__header__close {
    display: none;
}

.baloa-play-create-clip-modal .modal2__container  {
    width: 530px;
}

.baloa-play-create-clip-modal__container {
    text-align: center;
}

.baloa-play-create-clip-modal__form {
    padding: 18px 28px;
}

.baloa-play-create-clip-modal__form .input-field {
    margin: 0;
    margin-top: 20px;
}

.baloa-play-create-clip-modal__form .input-field-label {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
}

.baloa-play-create-clip-modal__form .input-field-input {
    border-radius: 8px;
    border: 1px solid var(--new-gray-background-color);
    background: var(--white-color);
    padding: var(--space) var(--space-half);
}

.baloa-play-create-clip-modal__form__info-container {
    background: var(--new-informative-banner-bg-color);
    padding: 8px;
    border-radius: 4px;
    margin-top: 12px;
}

.baloa-play-create-clip-modal__form__info-container .hubicon-info {
    font-size: 18px;
}

.baloa-play-create-clip-modal__form__info-container .hubicon-info:before {
    color: var(--new-informative-banner-color);
}

.baloa-play-create-clip-modal__form__info-container .baloa-table {
    color: var(--primary-very-dark-color);
    margin-top: 10px;
}

.baloa-play-create-clip-modal__form__info-container li.baloa-table {
    text-align: start;
    margin-top: 12px;
}

.baloa-play-create-clip-modal__form__info-container .baloa-table .value {
    font-weight: var(--font-medium);
}

.baloa-play-create-clip-modal__form__info-container li.baloa-table:first-of-type {
    margin-top: 12px;
}

.baloa-play-create-clip-modal__buttons {
    padding: 12px 28px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-top: 1px solid var(--new-gray-background-color);
    gap: 8px;
}

.baloa-play-create-clip-modal__buttons .button {
    padding: 12px 24px;
}

.baloa-play-create-clip-modal__buttons .button.text-button {
    color: var(--primary-very-dark-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .baloa-play-create-clip-modal .modal2__container{
        margin: 0;
        width: 100%;
        border-radius: 13px 13px 0px 0px;
        position: fixed;
        bottom: 0;
        background: var(--white-color);
    }

    .baloa-play-create-clip-modal__container {
        padding: 22px 16px 12px 16px;
    }

    .baloa-play-create-clip-modal__title {
        font-size: 16px;
        margin-top: 12px;
    }

    .baloa-play-create-clip-modal__form {
        padding: 0;
    }

    .baloa-play-create-clip-modal__message {
        font-size: 14px;
        margin-top: 16px;
    }

    .baloa-play-create-clip-modal__buttons .button {
        font-size: 15px;
        width: 100%;
    }

    .baloa-play-create-clip-modal__buttons {
        flex-direction: column-reverse;        
        padding: 0;
        margin-top: 24px;
        border-top: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/baloa-play/components/baloa-play-create-clip-modal-component/BaloaPlayCreateClipModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,8BAA8B;IAC9B,uCAAuC;AAC3C;;AAEA;IACI,kDAAkD;IAClD,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,sDAAsD;IACtD,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,SAAS;QACT,WAAW;QACX,gCAAgC;QAChC,eAAe;QACf,SAAS;QACT,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,8BAA8B;QAC9B,UAAU;QACV,gBAAgB;QAChB,gBAAgB;IACpB;AACJ","sourcesContent":[".baloa-play-create-clip-modal .modal2__header__close {\n    display: none;\n}\n\n.baloa-play-create-clip-modal .modal2__container  {\n    width: 530px;\n}\n\n.baloa-play-create-clip-modal__container {\n    text-align: center;\n}\n\n.baloa-play-create-clip-modal__form {\n    padding: 18px 28px;\n}\n\n.baloa-play-create-clip-modal__form .input-field {\n    margin: 0;\n    margin-top: 20px;\n}\n\n.baloa-play-create-clip-modal__form .input-field-label {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.baloa-play-create-clip-modal__form .input-field-input {\n    border-radius: 8px;\n    border: 1px solid var(--new-gray-background-color);\n    background: var(--white-color);\n    padding: var(--space) var(--space-half);\n}\n\n.baloa-play-create-clip-modal__form__info-container {\n    background: var(--new-informative-banner-bg-color);\n    padding: 8px;\n    border-radius: 4px;\n    margin-top: 12px;\n}\n\n.baloa-play-create-clip-modal__form__info-container .hubicon-info {\n    font-size: 18px;\n}\n\n.baloa-play-create-clip-modal__form__info-container .hubicon-info:before {\n    color: var(--new-informative-banner-color);\n}\n\n.baloa-play-create-clip-modal__form__info-container .baloa-table {\n    color: var(--primary-very-dark-color);\n    margin-top: 10px;\n}\n\n.baloa-play-create-clip-modal__form__info-container li.baloa-table {\n    text-align: start;\n    margin-top: 12px;\n}\n\n.baloa-play-create-clip-modal__form__info-container .baloa-table .value {\n    font-weight: var(--font-medium);\n}\n\n.baloa-play-create-clip-modal__form__info-container li.baloa-table:first-of-type {\n    margin-top: 12px;\n}\n\n.baloa-play-create-clip-modal__buttons {\n    padding: 12px 28px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    border-top: 1px solid var(--new-gray-background-color);\n    gap: 8px;\n}\n\n.baloa-play-create-clip-modal__buttons .button {\n    padding: 12px 24px;\n}\n\n.baloa-play-create-clip-modal__buttons .button.text-button {\n    color: var(--primary-very-dark-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .baloa-play-create-clip-modal .modal2__container{\n        margin: 0;\n        width: 100%;\n        border-radius: 13px 13px 0px 0px;\n        position: fixed;\n        bottom: 0;\n        background: var(--white-color);\n    }\n\n    .baloa-play-create-clip-modal__container {\n        padding: 22px 16px 12px 16px;\n    }\n\n    .baloa-play-create-clip-modal__title {\n        font-size: 16px;\n        margin-top: 12px;\n    }\n\n    .baloa-play-create-clip-modal__form {\n        padding: 0;\n    }\n\n    .baloa-play-create-clip-modal__message {\n        font-size: 14px;\n        margin-top: 16px;\n    }\n\n    .baloa-play-create-clip-modal__buttons .button {\n        font-size: 15px;\n        width: 100%;\n    }\n\n    .baloa-play-create-clip-modal__buttons {\n        flex-direction: column-reverse;        \n        padding: 0;\n        margin-top: 24px;\n        border-top: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
